import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
    selector: 'app-menu-popup',
    templateUrl: './menu-popup.component.html',
    styleUrls: ['./menu-popup.component.scss'],
    animations: [
        trigger('popupAnimation', [
            state('void', style({ opacity: 0, transform: 'translateX(100%)' })), // Start off-screen (right)
            state('*', style({ opacity: 1, transform: 'translateX(0)' })), // Fully visible
            transition('void => *', [animate('300ms ease-out')]), // Slide in from right to left
            transition('* => void', [animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))]) // Slide out to the right
        ])
    ],
    standalone: false
})
export class MenuPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
